import { FC } from 'react';

import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

import {
  CROWDING_EXTRACTION,
  CROWDING_EXTRACTION_VALUES
} from 'constants/prescriptionOptions';
import { translate } from 'utils';

import { FormLabel } from './FormLabel/FormLabel';
import { If } from './Generics';
import RhfRadioGroup from './RadioGroup/RhfRadioGroup/RhfRadioGroup';
import { RHFTextArea } from './RHFTextArea/RHFTextArea';
import RhfToothChart from './ToothChart/RhfToothChart';

interface Props {
  isDisabled?: boolean;
  isUpperDisabled?: boolean;
  isLowerDisabled?: boolean;
}
const CrowdingExtraction: FC<Props> = ({
  isDisabled,
  isUpperDisabled,
  isLowerDisabled
}) => {
  const {
    watch,
    formState: { errors }
  } = useFormContext();
  const watchExtraction = watch(
    'treatmentSpecifications.ZenClearUltra.extraction.Extraction'
  );
  const restrictedToothChartValue = watch(
    'treatmentSpecifications.ZenClearUltra.toothInformation.toothChart'
  );
  const fieldError = _.get(
    errors,
    'treatmentSpecifications.ZenClearUltra.extraction'
  );

  return (
    <div className='mt-5'>
      <FormLabel
        label={translate('prescription.step16_extraction')}
        className='md:text-17px mb-4'
        error={!!fieldError}
        name={'extraction'}
      />
      <RhfRadioGroup
        inputProps={{ disabled: isDisabled }}
        options={CROWDING_EXTRACTION}
        name='treatmentSpecifications.ZenClearUltra.extraction.Extraction'
        className=' flex flex-row space-x-16'
        radioClassName='border-RADIO_BORDER'
        radioItemFont='md:text-17px text-sm '
      />
      <If condition={watchExtraction === CROWDING_EXTRACTION_VALUES.EXTRACTION}>
        <div className='my-6 ml-5'>
          <RhfToothChart
            isBaby={false}
            showError={false}
            name={`treatmentSpecifications.ZenClearUltra.extraction.toothChart`}
            disabled={isDisabled}
            isUpperDisabled={isUpperDisabled}
            isLowerDisabled={isLowerDisabled}
            isToothChartRestricted={true}
            restrictedToothChartValue={restrictedToothChartValue}
            isCrowdExtraction={true}
          />
        </div>

        <div className='bg-GRAY5 flex flex-col p-4 rounded-2xl mt-4'>
          <p className='mb-3 text-14px'>
            {translate('tooth_movement_restriction.instruction')}
          </p>
          <RHFTextArea
            name={`treatmentSpecifications.ZenClearUltra.extraction.primaryDentition`}
            autogrow
            inputProps={{
              disabled: isDisabled,
              placeholder: translate('settings.please_type_here')
            }}
            maxgrowHeight={260}
          />
        </div>
      </If>
    </div>
  );
};
export default CrowdingExtraction;
